exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* \"Edit defaults\" sits with the column it edits. The fields themselves stay dimmed and\r\n   read-only: this column shows what every site starts from, and the one beside it is\r\n   where a single site departs from that. */\r\n.default-column-head {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.default-column-note {\r\n    font-size: 11px;\r\n    color: #8a8a8a;\r\n    line-height: 1.5;\r\n    margin-bottom: 8px;\r\n    max-width: 420px;\r\n}\r\n\r\n.default-fields { opacity: 0.5; }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/whitelabels/whitelabel-configs/whitelabel-configs.component.css
// module id = 700
// module chunks = 0